<template>
  <div class="row no-gutters">
    <div :class="{'col-sm-6': isCustom, col: !isCustom}">
      <select class="form-control" @input="updateValue($event.target.value)" ref="select" :required="required"
              :value="value">
        <option disabled value="">Please choose</option>
        <option :value="d.value" v-for="d in data" :key="d.value">{{d.displayValue}}</option>
        <option :value="customValue ? customValue : '$'">other</option>
      </select>
      <div class="invalid-feedback">
        <slot name="invalid-feedback">Field is required.</slot>
      </div>
    </div>
    <div class="col-sm-6" v-if="isCustom">
      <input type="text" class="form-control"
             placeholder="Please specify" v-model="customValue" required>
      <div class="invalid-feedback">Field is required.</div>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      customValue: {
        get () {
          if (this.data.map(d => d.value).includes(this.value) || this.value === '$') return ''
          else return this.value
        },
        set (newVal) {
          this.updateValue(newVal)
        }
      },
      isCustom () {
        return !this.data.map(d => d.value).includes(this.value) && this.value && this.value !== ''
      }
    },
    methods: {
      updateValue (val) {
        this.$emit('input', val)
      }
    },
    props: {
      data: Array,
      required: {
        type: Boolean,
        default: false
      },
      value: String
    },
    updated () {
      if (this.$refs.select) this.$refs.select.value = this.value
    }
  }
</script>

<style scoped>
</style>
